import React from 'react';
import { Trophy, Star, Gift, Users } from 'lucide-react';

const reasons = [
  {
    icon: Trophy,
    title: "Premios Increíbles",
    description: "Gana lotes de Navidad premium y tarjetas regalo"
  },
  {
    icon: Star,
    title: "Comparte tu Creatividad",
    description: "Muestra tu talento decorativo al mundo"
  },
  {
    icon: Gift,
    title: "Experiencia Única",
    description: "Forma parte de una tradición navideña especial"
  },
  {
    icon: Users,
    title: "Comunidad Festiva",
    description: "Únete a una comunidad que ama la Navidad"
  }
];

export default function WhyParticipate() {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8">
      <h2 className="text-2xl font-bold mb-8 text-center">¿Por qué participar?</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
        {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return (
            <div 
              key={index}
              className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left space-y-3 sm:space-y-0 sm:space-x-4 p-4 rounded-xl hover:bg-white/5 transition-colors"
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
                <Icon className="h-6 w-6 text-secondary" />
              </div>
              <div>
                <h3 className="font-semibold mb-1">{reason.title}</h3>
                <p className="text-gray-200 text-sm">{reason.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}